module.exports = "<div class=\"ui padded grid\">\n  <div class=\"sixteen wide column\">\n    <h1>Home screen.</h1>\n    <p>Please use menu button (in top left corner) while we are creating this page.</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/home/template.html
// module id = 85
// module chunks = 0